import { render, staticRenderFns } from "./TicketContactCard.vue?vue&type=template&id=547940a3&scoped=true"
import script from "./TicketContactCard.vue?vue&type=script&lang=js"
export * from "./TicketContactCard.vue?vue&type=script&lang=js"
import style0 from "./TicketContactCard.vue?vue&type=style&index=0&id=547940a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547940a3",
  null
  
)

export default component.exports